"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destinationKeyFromCreateInput = destinationKeyFromCreateInput;
exports.destinationKeyFromApiDestination = destinationKeyFromApiDestination;
exports.destinationKeyFromPrismaDestination = destinationKeyFromPrismaDestination;
exports.classifyExperimentVariantChange = classifyExperimentVariantChange;
function destinationKeyFromCreateInput(destination) {
    if (destination.destinationType === 'LANDINGPAGE') {
        return `LANDINGPAGE:${destination.landingPageHash}`;
    }
    return `URL:${destination.destinationUrl}`;
}
function destinationKeyFromApiDestination(destination) {
    if (destination.destinationType === 'LANDINGPAGE') {
        return `LANDINGPAGE:${destination.landingPageHash}`;
    }
    return `URL:${destination.destinationUrl}`;
}
function destinationKeyFromPrismaDestination(destination) {
    var _a;
    if (destination.type === 'LANDINGPAGE') {
        if (!((_a = destination.landingPage) === null || _a === void 0 ? void 0 : _a.landingPageHash)) {
            throw new Error('LANDINGPAGE destination is missing landingPage.landingPageHash');
        }
        return `LANDINGPAGE:${destination.landingPage.landingPageHash}`;
    }
    if (!destination.url) {
        throw new Error('URL destination is missing url');
    }
    return `URL:${destination.url}`;
}
function classifyExperimentVariantChange(existing, next) {
    if (existing.length !== next.length) {
        return 'REQUIRES_RESTART';
    }
    const existingKeys = new Set(existing.map((v) => v.destinationKey));
    const nextKeys = new Set(next.map((v) => v.destinationKey));
    const removed = Array.from(existingKeys).filter((key) => !nextKeys.has(key));
    const added = Array.from(nextKeys).filter((key) => !existingKeys.has(key));
    if (removed.length === 0 && added.length === 0) {
        const nextWeightByKey = new Map(next.map((v) => [v.destinationKey, v.weight]));
        for (const variant of existing) {
            if (nextWeightByKey.get(variant.destinationKey) !== variant.weight) {
                return 'REQUIRES_RESTART';
            }
        }
        return 'UNCHANGED';
    }
    if (removed.length !== 1 || added.length !== 1) {
        return 'REQUIRES_RESTART';
    }
    const removedVariant = existing.find((v) => v.destinationKey === removed[0]);
    const addedVariant = next.find((v) => v.destinationKey === added[0]);
    if (removedVariant.weight !== addedVariant.weight) {
        return 'REQUIRES_RESTART';
    }
    const nextWeightByKey = new Map(next.map((v) => [v.destinationKey, v.weight]));
    for (const variant of existing) {
        if (variant.destinationKey === removed[0]) {
            continue;
        }
        if (nextWeightByKey.get(variant.destinationKey) !== variant.weight) {
            return 'REQUIRES_RESTART';
        }
    }
    return 'SINGLE_DESTINATION_SWAP';
}
